import store from "../store";

export default (to, from, next) => {
  if (!store.getters["auth/user"]) {
    store.watch(
      (state, getters) => getters["auth/userLogging"],
      async (value) => {
        if (!value && store.getters["auth/user"]) next();
        if (!value && !store?.getters?.user) next({ path: "/login" });
      }
    );
  } else next();
};
